import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const linkCls = ({ isActive }) =>
  `text-sm tracking-wide transition-colors duration-200 ${isActive ? "text-primary" : "text-white/70 hover:text-white"}`;

const NavItems = ({ user, onLogout, onClick }) => (
  <>
    <NavLink to="/search" className={linkCls} onClick={onClick} data-testid="nav-search-link">
      Find Extras
    </NavLink>
    <NavLink to="/casting-calls" className={linkCls} onClick={onClick} data-testid="nav-casting-calls-link">
      Casting Calls
    </NavLink>
    <NavLink to="/casting-request" className={linkCls} onClick={onClick} data-testid="nav-casting-request-link">
      Request Extras
    </NavLink>
    {user && user.role === "admin" && (
      <NavLink to="/admin" className={linkCls} onClick={onClick} data-testid="nav-admin-link">
        Admin
      </NavLink>
    )}
    {user ? (
      <>
        {user.role !== "admin" && (
          <NavLink to="/dashboard" className={linkCls} onClick={onClick} data-testid="nav-dashboard-link">
            My Profile
          </NavLink>
        )}
        <button onClick={onLogout} className="text-sm text-white/70 hover:text-white transition-colors" data-testid="nav-logout-button">
          Log out
        </button>
      </>
    ) : (
      <>
        <NavLink to="/login" className={linkCls} onClick={onClick} data-testid="nav-login-link">
          Log in
        </NavLink>
        <Link
          to="/register"
          onClick={onClick}
          className="bg-primary text-primary-foreground px-5 py-2.5 text-sm font-bold uppercase tracking-wider hover:bg-[hsl(43,100%,60%)] transition-colors"
          data-testid="nav-join-button"
        >
          Get Listed
        </Link>
      </>
    )}
  </>
);

export const Navbar = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const onLogout = async () => {
    setOpen(false);
    await logout();
    navigate("/");
  };
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="font-display text-2xl font-bold tracking-tight" data-testid="nav-logo">
          extras<span className="text-primary">.tv</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavItems user={user} onLogout={onLogout} />
        </nav>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden flex flex-col gap-5 px-6 pb-6 pt-2 bg-black/90 border-t border-white/10" data-testid="nav-mobile-menu">
          <NavItems user={user} onLogout={onLogout} onClick={() => setOpen(false)} />
        </nav>
      )}
    </header>
  );
};
